import { useFormContext, useFormField } from '@calendly/form';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { RichTextField } from 'components/core/form';
import { supportedFormattingForBody } from './config';
import { useTextField } from '../hooks/use_text_field';
const styledRichTextFieldCss = "s1l0b3nd";
const StyledRichTextField = forwardRef((props, ref) => <RichTextField ref={ref} {...props} className={classNames(styledRichTextFieldCss, props.className)} />);
export const BodyField = ({
  ...props
}) => {
  const [{
    name,
    value
  }] = useFormField(props);
  const fieldProps = useTextField(props);
  const {
    setFieldError
  } = useFormContext();
  useEffect(() => {
    setFieldError(name, '');
  }, [name, setFieldError, value]);
  return <StyledRichTextField {...fieldProps} id="body" supportedFormatting={supportedFormattingForBody} />;
};

require("./body_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./body_field.js");